import React, { useState, useMemo } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import axios from "axios";
import CommonTable from "../../../common/CommonTable";

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL || 'http://127.0.0.1:8000/';

const DatapanelDeathdata = () => {
  const [selectedYears, setSelectedYears] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const years = [
    { name: "2025", value: "2025" },
    { name: "2024", value: "2024" },
    { name: "2023", value: "2023" },
    { name: "2022", value: "2022" },
    { name: "2021", value: "2021" },
    { name: "2020", value: "2020" },
  ];

  const handleDeathSearch = async (e) => {
    e.preventDefault();
    if (!selectedYears.length) {
      alert("Please select at least one year.");
      return;
    }
    setLoading(true);
    setHasSearched(true);

    const payload = {
      year: selectedYears,
    };

    try {
      const response = await axios.post(
        `${backendUrl}roadaccident/filter_death_details/`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        setFilterData(response.data);
      } else {
        console.error("Failed to fetch filtered data");
        setFilterData([]);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setFilterData([]);
      alert("Error fetching data: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(() => [
    { key: 'SlNo', label: 'S.No' },
    { key: 'year', label: 'Year', sortable: true },
    { key: 'municipality', label: 'Municipality', sortable: true },
    { key: 'submunicipality', label: 'Sub-Municipality', sortable: true },
    { key: 'suco', label: 'Suco', sortable: true },
    { key: 'location', label: 'Location' },
    { key: 'numberofaccidents', label: 'Number of Accidents', align: 'right' },
    { key: 'numberofinjured', label: 'Number of Injured', align: 'right' },
    { key: 'numberoffatal', label: 'Number of Fatalities', align: 'right' },
  ], []);

  return (
    <>
      <div className="formcontainer1">
        <Form onSubmit={handleDeathSearch}>
          <Row className="align-items-center">
            <Col md={6}>
              <Form.Group className="d-flex align-items-center gap-3">
                <Form.Label className="mb-0">Year</Form.Label>
                <MultiSelect
                  value={selectedYears}
                  onChange={(e) => setSelectedYears(e.value)}
                  options={years}
                  optionLabel="name"
                  display="chip"
                  placeholder="Select Year(s)"
                  className="w-full md:w-20rem"
                  style={{ width: "400px", fontSize: "13px" }}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="d-flex gap-3">
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? "Searching..." : "Search"}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>

      {hasSearched && (
        <div className="formcontainer1 mt-4">
          <CommonTable
            tableData={filterData}
            columns={columns}
            searchableKeys={['municipality', 'submunicipality', 'suco', 'location']}
            tableName="Death_Data_Directory"
            emptyMessage="No death data records found."
          />
        </div>
      )}
    </>
  );
};

export default DatapanelDeathdata;
